import { apiUrl } from '../api/config'
import axios from 'axios'

export default {
  login (data, cb, errorCb) {
    let formData = new FormData()
    let respondObj = {
      status: null,
      authKey: null,
      userId: null
    }
    formData.append('_password', data.pass)
    formData.append('_username', data.login)

    axios.post(apiUrl + 'authorized/login_check', formData)
      .then(response => {
        if (response.data.token) {
          respondObj.status = 'ok'
          respondObj.authKey = response.data.token

          if (response.data.userId) {
            respondObj.userId = response.data.userId
          }
        } else {
          console.log('Login respond error / no token')
        }
        cb(respondObj)
      })
      .catch(err => {
        if (err.response && err.response.status) {
          respondObj.status = err.response.status
          cb(respondObj)
        } else {
          errorCb(err)
        }
      })
  }
}
